import {
  // Calculation actions
  FETCH_CALCULATIONS_REQUEST,
  FETCH_CALCULATIONS_SUCCESS,
  FETCH_CALCULATIONS_FAILURE,
  FETCH_CALCULATION_REQUEST,
  FETCH_CALCULATION_SUCCESS,
  FETCH_CALCULATION_FAILURE,
  CREATE_CALCULATION_REQUEST,
  CREATE_CALCULATION_SUCCESS,
  CREATE_CALCULATION_FAILURE,
  UPDATE_CALCULATION_REQUEST,
  UPDATE_CALCULATION_SUCCESS,
  UPDATE_CALCULATION_FAILURE,
  DELETE_CALCULATION_REQUEST,
  DELETE_CALCULATION_SUCCESS,
  DELETE_CALCULATION_FAILURE,
  
  // Calculation Item actions
  FETCH_CALCULATION_ITEMS_REQUEST,
  FETCH_CALCULATION_ITEMS_SUCCESS,
  FETCH_CALCULATION_ITEMS_FAILURE,
  CREATE_CALCULATION_ITEM_REQUEST,
  CREATE_CALCULATION_ITEM_SUCCESS,
  CREATE_CALCULATION_ITEM_FAILURE,
  UPDATE_CALCULATION_ITEM_REQUEST,
  UPDATE_CALCULATION_ITEM_SUCCESS,
  UPDATE_CALCULATION_ITEM_FAILURE,
  DELETE_CALCULATION_ITEM_REQUEST,
  DELETE_CALCULATION_ITEM_SUCCESS,
  DELETE_CALCULATION_ITEM_FAILURE,
  
  // Export/Import actions
  EXPORT_CALCULATION_REQUEST,
  EXPORT_CALCULATION_SUCCESS,
  EXPORT_CALCULATION_FAILURE,
  IMPORT_CALCULATION_REQUEST,
  IMPORT_CALCULATION_SUCCESS,
  IMPORT_CALCULATION_FAILURE,
  IMPORT_CALCULATION_OLD_REQUEST,
  IMPORT_CALCULATION_OLD_SUCCESS,
  IMPORT_CALCULATION_OLD_FAILURE,
  
  // UI actions
  SELECT_CALCULATION,
  CLEAR_SELECTED_CALCULATION
} from './action-types';

// Calculation Actions
export const fetchCalculations = (params = {}) => ({
  type: FETCH_CALCULATIONS_REQUEST,
  payload: params
});

export const fetchCalculationsSuccess = (data) => ({
  type: FETCH_CALCULATIONS_SUCCESS,
  payload: data
});

export const fetchCalculationsFailure = (error) => ({
  type: FETCH_CALCULATIONS_FAILURE,
  payload: error
});

export const fetchCalculation = (id) => ({
  type: FETCH_CALCULATION_REQUEST,
  payload: { id }
});

export const fetchCalculationSuccess = (data) => ({
  type: FETCH_CALCULATION_SUCCESS,
  payload: data
});

export const fetchCalculationFailure = (error) => ({
  type: FETCH_CALCULATION_FAILURE,
  payload: error
});

export const createCalculation = (data) => ({
  type: CREATE_CALCULATION_REQUEST,
  payload: data
});

export const createCalculationSuccess = (data) => ({
  type: CREATE_CALCULATION_SUCCESS,
  payload: data
});

export const createCalculationFailure = (error) => ({
  type: CREATE_CALCULATION_FAILURE,
  payload: error
});

export const updateCalculation = (id, data) => ({
  type: UPDATE_CALCULATION_REQUEST,
  payload: { id, data }
});

export const updateCalculationSuccess = (data) => ({
  type: UPDATE_CALCULATION_SUCCESS,
  payload: data
});

export const updateCalculationFailure = (error) => ({
  type: UPDATE_CALCULATION_FAILURE,
  payload: error
});

export const deleteCalculation = (id) => ({
  type: DELETE_CALCULATION_REQUEST,
  payload: { id }
});

export const deleteCalculationSuccess = (id) => ({
  type: DELETE_CALCULATION_SUCCESS,
  payload: { id }
});

export const deleteCalculationFailure = (error) => ({
  type: DELETE_CALCULATION_FAILURE,
  payload: error
});

// Calculation Item Actions
export const fetchCalculationItems = (calculationId) => ({
  type: FETCH_CALCULATION_ITEMS_REQUEST,
  payload: { calculationId }
});

export const fetchCalculationItemsSuccess = (items) => ({
  type: FETCH_CALCULATION_ITEMS_SUCCESS,
  payload: items
});

export const fetchCalculationItemsFailure = (error) => ({
  type: FETCH_CALCULATION_ITEMS_FAILURE,
  payload: error
});

export const createCalculationItem = (calculationId, itemData) => ({
  type: CREATE_CALCULATION_ITEM_REQUEST,
  payload: { calculationId, itemData }
});

export const createCalculationItemSuccess = (item) => ({
  type: CREATE_CALCULATION_ITEM_SUCCESS,
  payload: item
});

export const createCalculationItemFailure = (error) => ({
  type: CREATE_CALCULATION_ITEM_FAILURE,
  payload: error
});

export const updateCalculationItem = (itemId, itemData, calculationId) => ({
  type: UPDATE_CALCULATION_ITEM_REQUEST,
  payload: { itemId, itemData, calculationId }
});

export const updateCalculationItemSuccess = (item) => ({
  type: UPDATE_CALCULATION_ITEM_SUCCESS,
  payload: item
});

export const updateCalculationItemFailure = (error) => ({
  type: UPDATE_CALCULATION_ITEM_FAILURE,
  payload: error
});

export const deleteCalculationItem = (itemId, calculationId) => ({
  type: DELETE_CALCULATION_ITEM_REQUEST,
  payload: { itemId, calculationId }
});

export const deleteCalculationItemSuccess = (itemId) => ({
  type: DELETE_CALCULATION_ITEM_SUCCESS,
  payload: { itemId }
});

export const deleteCalculationItemFailure = (error) => ({
  type: DELETE_CALCULATION_ITEM_FAILURE,
  payload: error
});

// Export/Import Actions
export const exportCalculation = (id) => ({
  type: EXPORT_CALCULATION_REQUEST,
  payload: { id }
});

export const exportCalculationSuccess = () => ({
  type: EXPORT_CALCULATION_SUCCESS
});

export const exportCalculationFailure = (error) => ({
  type: EXPORT_CALCULATION_FAILURE,
  payload: error
});

export const importCalculation = (file) => ({
  type: IMPORT_CALCULATION_REQUEST,
  payload: { file }
});

export const importCalculationSuccess = (data) => ({
  type: IMPORT_CALCULATION_SUCCESS,
  payload: data
});

export const importCalculationFailure = (error) => ({
  type: IMPORT_CALCULATION_FAILURE,
  payload: error
});

export const importCalculationOld = (file) => ({
  type: IMPORT_CALCULATION_OLD_REQUEST,
  payload: { file }
});

export const importCalculationOldSuccess = (data) => ({
  type: IMPORT_CALCULATION_OLD_SUCCESS,
  payload: data
});

export const importCalculationOldFailure = (error) => ({
  type: IMPORT_CALCULATION_OLD_FAILURE,
  payload: error
});

// UI Actions
export const selectCalculation = (calculation) => ({
  type: SELECT_CALCULATION,
  payload: calculation
});

export const clearSelectedCalculation = () => ({
  type: CLEAR_SELECTED_CALCULATION
});
